/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FinancialSummaryTotalDto
 */
export interface FinancialSummaryTotalDto {
    /**
     * 
     * @type {string}
     * @memberof FinancialSummaryTotalDto
     */
    previousIncurredOurLayer: string;
    /**
     * 
     * @type {string}
     * @memberof FinancialSummaryTotalDto
     */
    previousIncurredOurShare: string;
    /**
     * 
     * @type {string}
     * @memberof FinancialSummaryTotalDto
     */
    paymentsOurLayer: string;
    /**
     * 
     * @type {string}
     * @memberof FinancialSummaryTotalDto
     */
    paymentsOurShare: string;
    /**
     * 
     * @type {string}
     * @memberof FinancialSummaryTotalDto
     */
    outstandingOurLayer: string;
    /**
     * 
     * @type {string}
     * @memberof FinancialSummaryTotalDto
     */
    outstandingOurShare: string;
    /**
     * 
     * @type {string}
     * @memberof FinancialSummaryTotalDto
     */
    newIncurredOurLayer: string;
    /**
     * 
     * @type {string}
     * @memberof FinancialSummaryTotalDto
     */
    newIncurredOurShare: string;
}

/**
 * Check if a given object implements the FinancialSummaryTotalDto interface.
 */
export function instanceOfFinancialSummaryTotalDto(value: object): value is FinancialSummaryTotalDto {
    if (!('previousIncurredOurLayer' in value) || value['previousIncurredOurLayer'] === undefined) return false;
    if (!('previousIncurredOurShare' in value) || value['previousIncurredOurShare'] === undefined) return false;
    if (!('paymentsOurLayer' in value) || value['paymentsOurLayer'] === undefined) return false;
    if (!('paymentsOurShare' in value) || value['paymentsOurShare'] === undefined) return false;
    if (!('outstandingOurLayer' in value) || value['outstandingOurLayer'] === undefined) return false;
    if (!('outstandingOurShare' in value) || value['outstandingOurShare'] === undefined) return false;
    if (!('newIncurredOurLayer' in value) || value['newIncurredOurLayer'] === undefined) return false;
    if (!('newIncurredOurShare' in value) || value['newIncurredOurShare'] === undefined) return false;
    return true;
}

export function FinancialSummaryTotalDtoFromJSON(json: any): FinancialSummaryTotalDto {
    return FinancialSummaryTotalDtoFromJSONTyped(json, false);
}

export function FinancialSummaryTotalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinancialSummaryTotalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'previousIncurredOurLayer': json['previousIncurredOurLayer'],
        'previousIncurredOurShare': json['previousIncurredOurShare'],
        'paymentsOurLayer': json['paymentsOurLayer'],
        'paymentsOurShare': json['paymentsOurShare'],
        'outstandingOurLayer': json['outstandingOurLayer'],
        'outstandingOurShare': json['outstandingOurShare'],
        'newIncurredOurLayer': json['newIncurredOurLayer'],
        'newIncurredOurShare': json['newIncurredOurShare'],
    };
}

export function FinancialSummaryTotalDtoToJSON(json: any): FinancialSummaryTotalDto {
    return FinancialSummaryTotalDtoToJSONTyped(json, false);
}

export function FinancialSummaryTotalDtoToJSONTyped(value?: FinancialSummaryTotalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'previousIncurredOurLayer': value['previousIncurredOurLayer'],
        'previousIncurredOurShare': value['previousIncurredOurShare'],
        'paymentsOurLayer': value['paymentsOurLayer'],
        'paymentsOurShare': value['paymentsOurShare'],
        'outstandingOurLayer': value['outstandingOurLayer'],
        'outstandingOurShare': value['outstandingOurShare'],
        'newIncurredOurLayer': value['newIncurredOurLayer'],
        'newIncurredOurShare': value['newIncurredOurShare'],
    };
}

